
import React from 'react';
import ValidationErrors from '../components/ValidationErrors';

interface ValidationSectionProps {
  errors: string[];
}

const ValidationSection: React.FC<ValidationSectionProps> = ({ errors }) => {
  return <ValidationErrors errors={errors} />;
};

export default ValidationSection;
